import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { FileSignature, Check } from "lucide-react";

export const ContractsPanel = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/contracts/mine").then(({ data }) => setItems(data.items || [])).catch(() => {});
  }, []);
  if (items.length === 0) return null;
  const pending = items.filter((c) => c.status === "pending");
  return (
    <div className="card-dark p-5" data-testid="contracts-panel">
      <div className="flex items-center gap-2 mb-3">
        <FileSignature className="w-4 h-4 text-[var(--if-gold)]" />
        <span className="font-mono-label text-[var(--if-gold)]">Contracts</span>
      </div>
      <div className="flex flex-col gap-2.5">
        {items.map((c) => (
          <div key={c.id} className={`rounded-lg border px-3 py-2.5 flex items-center justify-between gap-3 ${c.status === "pending" ? "border-amber-400/40 bg-amber-400/8" : "border-white/10 bg-white/5"}`} data-testid={`contract-row-${c.id}`}>
            <div className="min-w-0">
              <div className="text-sm text-white truncate" style={{ fontFamily: "Inter, sans-serif" }}>{c.template_name}</div>
              <div className="text-[11px] text-white/45" style={{ fontFamily: "Inter, sans-serif" }}>
                {c.status === "pending" ? `Sent ${String(c.sent_at).slice(0, 10)} — awaiting your signature` : `Signed ${String(c.signed_at).slice(0, 10)}`}
              </div>
            </div>
            {c.status === "pending" ? (
              <Link to={`/sign/${c.id}`} className="btn-gold !py-1.5 !px-3.5 !text-[10px] shrink-0" data-testid={`contract-sign-link-${c.id}`}>
                Review &amp; Sign
              </Link>
            ) : (
              <span className="inline-flex items-center gap-1 text-[11px] text-[#4F5D1E] shrink-0" style={{ fontFamily: "Inter, sans-serif" }}>
                <Check className="w-3.5 h-3.5" /> Signed
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
